import React from 'react';

/*
  PRODUCT-LINE BADGE -- the Ruby Till wordmark style ("Ruby" in white, the
  line name in a ruby pill) as a small chip, so a package card says which
  product line it belongs to before anyone opens it.

    rubytill (or unset)  ->  [Ruby Till]
    rubyestate           ->  [Ruby Estate]
    shared               ->  [Ruby Till] [Ruby Estate]   (on both menus)
*/
export type ProductLine = 'rubytill' | 'rubyestate' | 'shared';

const LineChip: React.FC<{ name: 'Till' | 'Estate'; size: 'sm' | 'md' }> = ({ name, size }) => {
  const sm = size === 'sm';
  return (
    <span
      className="inline-flex items-center rounded-full bg-black shadow-sm select-none"
      style={{ gap: sm ? 4 : 5, padding: sm ? '3px 3px 3px 9px' : '4px 4px 4px 11px' }}
      aria-label={`Ruby ${name}`}
      title={`Ruby ${name}`}
    >
      <span className="font-extrabold text-white leading-none tracking-tight" style={{ fontSize: sm ? 11.5 : 13 }} aria-hidden="true">Ruby</span>
      <span
        className="font-extrabold text-white leading-none tracking-tight"
        style={{ background: '#D9363E', borderRadius: sm ? 6 : 7, padding: sm ? '3px 7px' : '4px 8px', fontSize: sm ? 11.5 : 13 }}
        aria-hidden="true"
      >
        {name}
      </span>
    </span>
  );
};

export const ProductLineBadge: React.FC<{ line?: ProductLine | null; size?: 'sm' | 'md'; className?: string }> = ({ line, size = 'sm', className = '' }) => {
  const l: ProductLine = line === 'rubyestate' || line === 'shared' ? line : 'rubytill';
  return (
    <span className={`inline-flex items-center gap-1.5 flex-wrap ${className}`} data-testid="product-line-badge" data-line={l}>
      {(l === 'rubytill' || l === 'shared') && <LineChip name="Till" size={size} />}
      {(l === 'rubyestate' || l === 'shared') && <LineChip name="Estate" size={size} />}
      {l === 'shared' && <span className="text-[10px] font-semibold uppercase tracking-wide text-stone-500">Shared</span>}
    </span>
  );
};

export default ProductLineBadge;
